'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _url = require('url');

var _url2 = _interopRequireDefault(_url);

var _languageHandler = require('../../../languageHandler');

var _WidgetUtils = require('../../../utils/WidgetUtils');

var _WidgetUtils2 = _interopRequireDefault(_WidgetUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppPermission = function (_React$Component) {
    (0, _inherits3.default)(AppPermission, _React$Component);

    function AppPermission(props) {
        (0, _classCallCheck3.default)(this, AppPermission);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AppPermission.__proto__ || (0, _getPrototypeOf2.default)(AppPermission)).call(this, props));

        var curlBase = _this.getCurlBase();
        _this.state = { curlBase: curlBase };
        return _this;
    }

    // Return string representation of content URL without query parameters


    (0, _createClass3.default)(AppPermission, [{
        key: 'getCurlBase',
        value: function getCurlBase() {
            var wurl = _url2.default.parse(this.props.url);
            var curl = void 0;
            var curlString = void 0;

            var searchParams = new URLSearchParams(wurl.search);

            if (_WidgetUtils2.default.isScalarUrl(wurl) && searchParams && searchParams.get('url')) {
                curl = _url2.default.parse(searchParams.get('url'));
                if (curl) {
                    curl.search = curl.query = "";
                    curlString = curl.format();
                }
            }
            if (!curl && wurl) {
                wurl.search = wurl.query = "";
                curlString = wurl.format();
            }
            return curlString;
        }
    }, {
        key: 'render',
        value: function render() {
            var e2eWarningText = void 0;
            if (this.props.isRoomEncrypted) {
                e2eWarningText = _react2.default.createElement(
                    'span',
                    { className: 'mx_AppPermissionWarningTextLabel' },
                    (0, _languageHandler._t)('NOTE: Apps are not end-to-end encrypted')
                );
            }
            var cookieWarning = _react2.default.createElement(
                'span',
                { className: 'mx_AppPermissionWarningTextLabel' },
                (0, _languageHandler._t)('Warning: This widget might use cookies.')
            );
            return _react2.default.createElement(
                'div',
                { className: 'mx_AppPermissionWarning' },
                _react2.default.createElement(
                    'div',
                    { className: 'mx_AppPermissionWarningImage' },
                    _react2.default.createElement('img', { src: require("../../../../res/img/feather-customised/warning-triangle.svg"), alt: (0, _languageHandler._t)('Warning!') })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_AppPermissionWarningText' },
                    _react2.default.createElement(
                        'span',
                        { className: 'mx_AppPermissionWarningTextLabel' },
                        (0, _languageHandler._t)('Do you want to load widget from URL:')
                    ),
                    ' ',
                    _react2.default.createElement(
                        'span',
                        { className: 'mx_AppPermissionWarningTextURL' },
                        this.state.curlBase
                    ),
                    e2eWarningText,
                    cookieWarning
                ),
                _react2.default.createElement('input', {
                    className: 'mx_AppPermissionButton',
                    type: 'button',
                    value: (0, _languageHandler._t)('Allow'),
                    onClick: this.props.onPermissionGranted
                })
            );
        }
    }]);
    return AppPermission;
}(_react2.default.Component);

exports.default = AppPermission;


AppPermission.propTypes = {
    isRoomEncrypted: _propTypes2.default.bool,
    url: _propTypes2.default.string.isRequired,
    onPermissionGranted: _propTypes2.default.func.isRequired
};
AppPermission.defaultProps = {
    isRoomEncrypted: false,
    onPermissionGranted: function onPermissionGranted() {}
};
module.exports = exports['default'];
//# sourceMappingURL=AppPermission.js.map